import type { GetGameBlindsRow } from '@/tygo/db'
import { apiFetch } from '@/lib/http'

const GAME_BLIND_BASE = '/api/v1/game_blind'

type GetGameBlindsInput = {
  access_token: string
}

export function getGameBlinds(input: GetGameBlindsInput) {
  return apiFetch<Array<GetGameBlindsRow>>(`${GAME_BLIND_BASE}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${input.access_token}`,
    },
  })
}
